export default "__VITE_ASSET__Ch2JasYd__"